var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticStyle: { height: "100%" } },
    [
      _c(
        "div",
        { staticClass: "toolbar-aste", class: { dark: _vm.darkTheme } },
        [
          _c(
            "v-layout",
            {
              staticClass: "items-center justify-center selected-bar",
              staticStyle: { gap: "2em" },
            },
            [
              _vm.config.nome_ciliare
                ? _c(
                    "v-flex",
                    {
                      staticClass: "ciliare item-menu",
                      class: { active: _vm.activeMenu === "ciliare" },
                      on: {
                        click: function ($event) {
                          return _vm.setActiveMenu("ciliare")
                        },
                      },
                    },
                    [_vm._v(" FRONTALE ")]
                  )
                : _vm._e(),
              _vm.config.nome_extdx
                ? _c(
                    "v-flex",
                    {
                      staticClass: "asta-destra item-menu",
                      class: { active: _vm.activeMenu === "astaDx" },
                      on: {
                        click: function ($event) {
                          return _vm.setActiveMenu("astaDx")
                        },
                      },
                    },
                    [_vm._v(" ASTA DESTRA ")]
                  )
                : _vm._e(),
              _vm.config.nome_extsx
                ? _c(
                    "v-flex",
                    {
                      staticClass: "asta-sinistra item-menu",
                      class: { active: _vm.activeMenu === "astaSx" },
                      on: {
                        click: function ($event) {
                          return _vm.setActiveMenu("astaSx")
                        },
                      },
                    },
                    [_vm._v(" ASTA SINISTRA ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-carousel",
        {
          staticClass: "carousel-personal-name",
          staticStyle: { overflow: "auto" },
          attrs: {
            "show-arrows": false,
            height: "auto",
            "hide-delimiters": "",
          },
          model: {
            value: _vm.carouselIndex,
            callback: function ($$v) {
              _vm.carouselIndex = $$v
            },
            expression: "carouselIndex",
          },
        },
        _vm._l(_vm.filteredLayouts, function (layout, index) {
          return _c(
            "v-carousel-item",
            { key: index, staticClass: "carousel-item" },
            [
              layout.activeMenu
                ? _c("custom-layout", {
                    staticClass: "carousel",
                    attrs: {
                      titlePreview: layout.name,
                      colors: _vm.colors,
                      previewComponent: layout.previewComponent,
                      selectedColor: _vm.getSelectedColor(index),
                      astaColor: _vm.coloreAste,
                      darkTheme: _vm.darkTheme,
                      keyName: layout.keyName,
                      moduleName: layout.moduleName,
                      colorMutation: layout.colorMutation,
                      nameMutation: layout.nameMutation,
                      fieldGetterName: layout.fieldGetterName,
                      nomeGetComp: layout.nomeGet,
                      fieldGetterColor: layout.fieldGetterColor,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }